import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <main className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-4xl font-bold text-gray-900">Page not found</h1>
        <p className="text-gray-600">
          The page you are looking for doesn&apos;t exist or may have been moved. Use the links below to get back on track.
        </p>
        <div className="flex flex-wrap justify-center gap-3 mt-4">
          <Link to="/" className="px-4 py-2 rounded-md bg-blue-600 text-white text-sm font-medium hover:bg-blue-700">
            Go to homepage
          </Link>
          <Link to="/pricing" className="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-white">
            View pricing
          </Link>
          <Link to="/contact" className="px-4 py-2 rounded-md border border-gray-300 text-sm font-medium text-gray-700 hover:bg-white">
            Contact us
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;

